import { Button, CircularProgress } from '@material-ui/core';

import AlertConectouEmOutroLocal from 'components/AlertConectouEmOutroLocal';
import AlertConnectError from 'components/AlertConnectError';
import ButtonAtualizarVersao from 'components/ButtonAtualizarVersao';
import DrawerTransferencias from 'components/DrawerTransferencias';
import EmptyState from 'components/EmptyState';
import ErrorBoundary from 'components/ErrorBoundary';
import ModalAguardandoEnvioArquivo from 'components/ModalAguardandoEnvioArquivo';
import ModalUsuarioDesautenticado from 'components/ModalUsuarioDesautenticado';
import useAuth from 'hooks/useAuth';
import Routes from 'routes';

export default function App() {
  const auth = useAuth();

  if (auth.loading) {
    return <AppFallbackComponent />;
  }

  if (auth.failed) {
    return <AppErrorComponent />;
  }

  return (
    <ErrorBoundary>
      <Routes />
      <AlertConnectError />
      <ButtonAtualizarVersao />
      <AlertConectouEmOutroLocal />
      <ModalUsuarioDesautenticado />
      <DrawerTransferencias />
      <ModalAguardandoEnvioArquivo />
    </ErrorBoundary>
  );
}

const AppFallbackComponent = () => (
  <EmptyState
    title="Um momento..."
    description={`"Estamos preparando o Tarelo para você"`}
    icon={<CircularProgress color="inherit" size={32} />}
  />
);

const AppErrorComponent = () => (
  <EmptyState
    title="Não foi possível carregar o Tarelo"
    description="Tente novamente em alguns instantes."
  >
    <Button
      variant="outlined"
      color="primary"
      onClick={() => window.location.reload()}
    >
      Tentar novamente
    </Button>
  </EmptyState>
);
